const SkillsData = [
  {
    type: "Languages",
    skills: [
      "Python",
      "C++",
      "JavaScript",
      "C#",
      "Swift",
      "HTML",
      "CSS",
      "PowerShell",
      "Bash",
    ],
  },
  {
    type: "Frameworks",
    skills: [
      "NumPy",
      "OpenCV",
      "EasyOCR",
      "TensorFlow",
      "SciPy",
      "Matplotlib",
      "React",
      "NodeJS",
      "Bootstrap",
    ],
  },
  {
    type: "Tools",
    skills: [
      "Git",
      "Selenium",
      "MySQL",
      "Adobe Illustrator",
      "Maple",
      "LaTeX",
      "MS Office365",
      "WordPress",
    ],
  },
];
export default SkillsData;
